import { 
  useState, 
  useEffect 
}                         from 'react';
import { connect }        from 'react-redux';
import { reducerType }    from 'reducer';
import { colors }         from 'utils/colors';
import CloseIcon          from '@mui/icons-material/Close';
import { makeStyles }     from 'makeStyles';
import { sizeStateType }  from 'reducer/types';


const useStyles = makeStyles ()(() => ({
    root: {
      //position: 'fixed',
      width:           '100%',
      height:          '100%',
      backgroundColor: colors.gridBackground,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      transition:      'opacity 1s',
    },
    icon: {
      position:        'absolute',
      marginTop:        10,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      height:          35,
      width:           35,
      zIndex:          2,
      borderRadius:    '50%',
      background:      '#FFF',
      cursor:          'pointer',
      border:          '1px solid #DDD',
      '&:hover': {
        opacity: 0.5
      }
    }
}))

type IframeProps = {
    sizeState: sizeStateType;
    src:       string;
    page:      string;
    width:     number | string;
    height:    number | string;
    color?:    string
}

const Iframe: React.FC<IframeProps> = ({ sizeState, src, page, width, height, color }) => {

  const { classes } = useStyles();

  const [opacity, setOpacity] = useState(0)
  

  useEffect(() => {
      setTimeout(() => {
        setOpacity(1)
      }, 50)
  },[])

  const onClick = () => { 
    import("functions/menu/menu_click").then(func => {
      func.menuClick('tutorial', 'tutorial')
    });
  }

  return (
  <>
    {
      page === 'puzzles' &&
    
       <div 
          className = { classes.icon }
          onClick   = { onClick }
          style     = {{
            right: sizeState.wideScreen ? sizeState.menuSize + 30 : 10
          }}
       >
          <CloseIcon/>
       </div>
    }
      <div 
        className = { classes.root }
        style     = {{
            opacity:         opacity,
            backgroundColor: !!color ? color : undefined
        }}
      >
        <iframe 
            title           = "I See Math"
            width           = { width }
            height          = { height }
            src             = { src }
            allow-scripts   = 'true'
            frameBorder     = "0"
            allowFullScreen
        />
    </div>
  </>
       
  );
}


const mapStateToProps = (reducer: reducerType) => {
  return {
    sizeState: reducer.size,
    page:      reducer.page.page
}};


export default connect(mapStateToProps)(Iframe);

